import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import MinCustomDialog from '../Dialogs/MinCustomDialog';
import CustomTextField from '../CustomInputs/CustomTextField';
import { Categories, AddressProsp } from '.';

const DialogAddProsp = ({
  open,
  addProsp,
  newProsp,
  setNewProsp,
  updateState
}) => (
  <MinCustomDialog
    open={open}
    onClose={() => updateState('openAddProsp', false)}
    maxWidth={'sm'}
    title={'Ajouter un prosp'}
    actions={[
      <Button key={1} onClick={() => updateState('openAddProsp', false)}
        color="secondary"> Annuler </Button>,
      <Button key={1} onClick={addProsp} color="primary"> Ajouter </Button>
    ]}
    middle children={
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <CustomTextField
            placeholder={'Nom'}
            value={newProsp.get('nom')}
            path={['nom']}
            setData={setNewProsp}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            placeholder={'Téléphone'}
            value={newProsp.get('tels')}
            path={['tels']}
            setData={setNewProsp}
          />
        </Grid>
        <Grid item xs={12}>
          <AddressProsp
            merge={newProsp}
            setData={setNewProsp}
            path={['address']}
          />
        </Grid>
        <Grid item xs={12}>
          <Categories
            setData={setNewProsp}
            merge={newProsp}
            path={['categorie']}
          />
        </Grid>
      </Grid>
    } />
);

export default (DialogAddProsp);
